<template>
    <div :class="{'dxreControlFullscreen': isFullscreen}">
        <div 
            ref="richEdit"
            @dragover.prevent
            @drop.prevent="onDropIntoEditor"
        />  
        <div :class="{
                    'richedit-action-panel': true,
                    'rap-full-screen': isFullscreen
                    }">
            <div
                class="richedit-action-btn" 
                :title="$t('Вставить_поля')"
            >
                <v-popover trigger="click" popoverClass="richedit-action-tooltip">
                    <i class="dx-icon dxre-icon-InsertDataField"></i>
                    <template slot="popover">
                        <draggable
                            v-model="mergeFields"
                            :group="{ name: 'fields', pull: 'clone', put: false }"
                            :clone="cloneField"
                            @start="onDragStart"
                            item-key="field"
                            class="ribbon-button-submenu rbs-draggable"
                            tag="ul"
                            :sort="false"
                        >
                            <li
                                v-for="field in mergeFields"
                                :key="field"
                            >
                                {{ field }}
                            </li>
                        </draggable>
                        <span class="ribbon-button-submenu-title">{{ $t('Вставка_полей_документа') }}</span>
                    </template>
                </v-popover>
            </div>
            <div
                class="richedit-action-btn" 
                :title="$t('На_весь_экран')"
                @click="toggleFullscreen"
            >
                <i class="dx-icon dxre-icon-FullScreen"></i>
            </div>   
        </div>
    </div>
</template>

<script>
import { locale, loadMessages } from "devextreme/localization";
import { create, createOptions, RichEdit, Interval, ViewType, RichEditUnit, DocumentFormat } from 'devexpress-richedit';
import ruMessages from '@/locales/richedit/dx-rich.ru.json';
import draggable from 'vuedraggable';

export default {
    name: "richedit-tab",
    rich: RichEdit,
    components: {
        draggable
    },
    data() {
        return {
            isFullscreen: false,
            mergeFields: ['Text', 'Date', 'Select', 'Switch'],
            mergeFieldsValues: {
                Text: 'Привет',
                Date: '21.07.2025',
                Select: 'Выбор',
                Switch: 'Вкл'
            },
            draggedField: null
        }
    },
    mounted(){
        
        loadMessages(ruMessages);
        locale("ru");

        // the createOptions() method creates an object that contains RichEdit options initialized with default values
        const options = createOptions();
        options.locale = "ru";
        options.bookmarks.visibility = true;
        options.bookmarks.color = '#ff0000';
        options.confirmOnLosingChanges.enabled = true;
        options.confirmOnLosingChanges.message = 'Are you sure you want to perform the action? All unsaved document data will be lost.';
        options.fields.updateFieldsBeforePrint = true;
        options.fields.updateFieldsOnPaste = true;
        //options.mailMerge.activeRecord = 2;
        options.mailMerge.viewMergedData = true;
        options.mailMerge.dataSource = [
            {
                Text: 'Привет',
                Date: '21.07.2025',
                Select: 'Выбор',
                Switch: 'Вкл'
            }
        ];
        // events
        options.events.activeSubDocumentChanged = () => { };
        options.events.autoCorrect = () => { };
        options.events.calculateDocumentVariable = () => { };
        options.events.characterPropertiesChanged = () => { };
        options.events.contentInserted = () => { };
        options.events.contentRemoved = () => { };
        options.events.documentChanged = () => { };
        options.events.documentFormatted = () => { };
        options.events.documentLoaded = () => { };
        options.events.gotFocus = () => { };
        options.events.hyperlinkClick = () => { };
        options.events.keyDown = () => { };
        options.events.keyUp = () => { };
        options.events.paragraphPropertiesChanged = () => { };
        options.events.lostFocus = () => { };
        options.events.pointerDown = () => { };
        options.events.pointerUp = () => { };
        options.events.saving = () => { };
        options.events.saved = () => { };
        options.events.selectionChanged = () => { };    
        options.events.customCommandExecuted = (s, e) => {
            switch (e.commandName) {
            case 'insertEmailSignature':
                s.document.insertParagraph(s.document.length);
                s.document.insertText(s.document.length, '_________');
                s.document.insertParagraph(s.document.length);
                s.document.insertText(s.document.length, 'Best regards,');
                s.document.insertParagraph(s.document.length);
                s.document.insertText(s.document.length, 'John Smith');
                s.document.insertParagraph(s.document.length);
                s.document.insertText(s.document.length, 'john@example.com');
                s.document.insertParagraph(s.document.length);
                s.document.insertText(s.document.length, '+1 (818) 844-0000');
                break;
            }
        };
        options.unit = RichEditUnit.Centimeter;
        options.view.viewType = ViewType.PrintLayout;
        options.view.simpleViewSettings.paddings = {
        left: 15,
        top: 15,
        right: 15,
        bottom: 15,
        };
        options.autoCorrect = {
            correctTwoInitialCapitals: true,
            detectUrls: true,
            enableAutomaticNumbering: true,
            replaceTextAsYouType: true,
            caseSensitiveReplacement: false,
            replaceInfoCollection: [
                { replace: "wnwd", with: "well-nourished, well-developed" },
                { replace: "(c)", with: "©" }
            ],
        };
        // capitalize the first letter at the beginning of a new sentence/line
        options.events.autoCorrect = function (s, e) {
            if (e.text.length == 1 && /\w/.test(e.text)) {
                var prevText = s.document.getText(new Interval(e.interval.start - 2, 2));
                if (prevText.length == 0 || /^([.]|[?]|[!] )$/.test(prevText) || prevText.charCodeAt(1) == 13) {
                    var newText = e.text.toUpperCase();
                    if (newText != e.text) {
                        s.beginUpdate();
                        s.history.beginTransaction();
                        s.document.deleteText(e.interval);
                        s.document.insertText(e.interval.start, newText);
                        s.history.endTransaction();
                        s.endUpdate();
                        e.handled = true;
                    }
                }
            }
        };  
        options.exportUrl = 'https://siteurl.com/api/';
        /*режим просмотра*/
        options.readOnly = false;
        options.ribbon.visible = true;
        /**/
        options.width = '100%';
        //options.height = '700px';
        this.rich = create(this.$refs.richEdit, options);

        var documentAsBase64 = "e1xydGYxXGRlZmYwe1xmb250dGJse1xmMCBDYWxpYnJpO319e1xjb2xvcnRibCA7XHJlZDB"
            + "cZ3JlZW4wXGJsdWUyNTUgO1xyZWQyNTVcZ3JlZW4yNTVcYmx1ZTI1NSA7fXtcKlxkZWZjaHAgXGZzMjJ9e1xzdHl"
            + "sZXNoZWV0IHtccWxcZnMyMiBOb3JtYWw7fXtcKlxjczFcZnMyMiBEZWZhdWx0IFBhcmFncmFwaCBGb250O317XCp"
            + "cY3MyXGZzMjJcY2YxIEh5cGVybGluazt9e1wqXHRzM1x0c3Jvd2RcZnMyMlxxbFx0c3ZlcnRhbHRcdHNjZWxsY2J"
            + "wYXQyXHRzY2VsbHBjdDBcY2x0eGxydGIgTm9ybWFsIFRhYmxlO319e1wqXGxpc3RvdmVycmlkZXRhYmxlfXtcaW5"
            + "mb31cbm91aWNvbXBhdFxzcGx5dHduaW5lXGh0bWF1dHNwXGV4cHNocnRuXHNwbHRwZ3BhclxkZWZ0YWI3MjBcc2V"
            + "jdGRcbWFyZ2xzeG4xNDQwXG1hcmdyc3huMTQ0MFxtYXJndHN4bjE0NDBcbWFyZ2JzeG4xNDQwXGhlYWRlcnk3MjB"
            + "cZm9vdGVyeTcyMFxwZ3dzeG4xMjI0MFxwZ2hzeG4xNTg0MFxjb2xzMVxjb2xzeDcyMFxwYXJkXHBsYWluXHFse1x"
            + "mczIyXGNmMFxjczEgRG9jdW1lbnQgdGV4dH1cZnMyMlxjZjBccGFyfQ==";
        this.rich.openDocument(documentAsBase64, 'DocumentName', DocumentFormat.Rtf);

        this.$nextTick(this.heightControlMethod);
        window.addEventListener('resize', this.heightControlMethod);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.heightControlMethod);
    },
    beforeUnmount() {
        if (this.rich) {
            this.rich.dispose();
            this.rich = null;
        }
    },
    methods: {
        triggerFileInput() {
            this.loadDocxFromPublic('/docs/sample.docx');
        },
        async loadDocxFromPublic(path) {
            try {
                const response = await fetch(path);
                const blob = await response.blob();
                const base64 = await this.blobToBase64(blob);
                this.rich.openDocument(base64, 'sample.docx', DocumentFormat.Docx);
            } catch (err) {
                console.error('Ошибка загрузки DOCX:', err);
            }
        },
        blobToBase64(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                const base64data = reader.result.split(',')[1]; // убрать data:*/*;base64,
                resolve(base64data);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        heightControlMethod() {
            var parent = document.getElementsByClassName('content-box')[0];
            var top_btns_bar_obj = parent.getElementsByClassName('top-btns-bar');
            var white_panel_obj = parent.getElementsByClassName('white-panel-items');
            var tab_selector_panel_obj = parent.getElementsByClassName('tab-selector-panel');
            var after_tabs_card_btn_obj = parent.getElementsByClassName('after-tabs-part-wrapper');
            var richtextedit_obj = parent.getElementsByClassName('dxreControl');

            var parent_h = parent.clientHeight;
            var toolbar_h = top_btns_bar_obj.length > 0 ? top_btns_bar_obj[0].clientHeight : 0;
            var white_panel_h = white_panel_obj.length > 0 ? white_panel_obj[0].clientHeight : 0;
            var tabs_margin_top = white_panel_obj.length > 0 ? 10 : 0;
            var after_tabs_card_btn_h = after_tabs_card_btn_obj.length > 0 ? after_tabs_card_btn_obj[0].clientHeight : 
            tab_selector_panel_obj[0].clientHeight;
            
            richtextedit_obj[0].style.height = (parent_h - (toolbar_h + white_panel_h + tabs_margin_top + after_tabs_card_btn_h + 49)) + "px";
        },
        toggleFullscreen() {
            this.isFullscreen = !this.isFullscreen;
            this.$nextTick(() => {
                const btn = document.querySelector('.dxre-icon-FullScreen')?.closest('[role="button"]');
                if (btn) {
                    btn.click();
                }
            });
        },
        //merge
        onDragStart(evt) {
            this.draggedField = evt.item?.textContent?.trim() || null;
        },
        cloneField(field) {
            return field;
        },
        onDropIntoEditor() {
            if (!this.rich || !this.draggedField) return;

            const { clientX, clientY } = event;

            // Шаг 1: найти элемент под мышкой
            const targetElement = document.elementFromPoint(clientX, clientY);

            if (targetElement) {
                // Шаг 2: эмулируем клик в эту точку — курсор RichEdit сместится
                const clickEvent = new MouseEvent("mousedown", {
                    bubbles: true,
                    cancelable: true,
                    clientX,
                    clientY
                });
                targetElement.dispatchEvent(clickEvent);

                const upEvent = new MouseEvent("mouseup", {
                    bubbles: true,
                    cancelable: true,
                    clientX,
                    clientY
                });
                targetElement.dispatchEvent(upEvent);

                // Шаг 3: подождать, чтобы курсор успел переместиться
                setTimeout(() => {
                    const pos = this.rich.selection.intervals[0].start;
                    var subDocument = this.rich.selection.activeSubDocument;
                    var field = subDocument.fields.createMergeField(pos, this.draggedField);
                    field.update(function(self) {
                        console.log(subDocument.getText(self.resultInterval)); 
                    });
                    
                    /*const search = `{{${this.draggedField}}}`;
                    const replacement = this.mergeFieldsValues[this.draggedField];

                    const content = this.rich.document.getText();
                    const startIndex = content.indexOf(search);

                    if (startIndex !== -1) {
                    const length = search.length;
                    const interval = new Interval(startIndex, length);

                    this.rich.document.deleteText(interval);
                    this.rich.document.insertText(startIndex, replacement);
                    }*/
                    this.draggedField = null;
                }, 20); // 1 тик таймера
            }
        }
    }
}
</script>